import React__default from 'react';
import { useController } from 'react-hook-form';
import { AddressInput } from '../../../organisms/AddressInput.js';
import { FormItem } from '../FormItem.js';
import { ReadOnlyField, formatReadOnlyValue } from './ReadOnlyFormField.js';

/**
 * AddressFormField - A form field component for address input.
 *
 * @example
 * ```tsx
 * <Form schema={schema} onSubmit={handleSubmit}>
 *   <AddressFormField
 *     schemaField="address"
 *     labelText="Address"
 *     placeholder="Start typing address"
 *   />
 * </Form>
 * ```
 */
function AddressFormField({ schemaField, labelText, descriptionText, isReadOnly, isDisabled, required, className, id, orientation, linkedField, showFieldToggle, ...addressInputProps }) {
    const { field } = useController({
        name: schemaField,
        shouldUnregister: false,
    });
    if (isReadOnly) {
        return (React__default.createElement(ReadOnlyField, { label: labelText, value: formatReadOnlyValue(field.value, 'address'), description: descriptionText, required: required, className: className }));
    }
    return (React__default.createElement(FormItem, { schemaField: schemaField, labelText: labelText, descriptionText: descriptionText, required: required, className: className, id: id, isDisabled: isDisabled, orientation: orientation, linkedField: linkedField, showFieldToggle: showFieldToggle },
        React__default.createElement(AddressInput, { ...addressInputProps })));
}

export { AddressFormField };
//# sourceMappingURL=AddressFormField.js.map
